module.exports = __webpack_public_path__ + "static/media/bz.c6b9ed7b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bz.svg
// module id = 828
// module chunks = 0